// Vista "¡Tarifa seleccionada!" compartida por el cotizador del landing
// (LandingQuote), el cotizador con IA (AIChatQuote) y la página pública
// /cotizar (CotizadorPublico). Detecta si el usuario tiene sesión iniciada y
// ofrece el botón "Capturar y generar guía" (logueado) o los botones
// "Crear cuenta gratis" / "Iniciar sesión" (sin sesión). El padre la monta
// dentro de su propio <Dialog> con el ancho que corresponda.
import { Package2, ArrowRight } from "lucide-react";
import { getCarrier } from "@/lib/carriers";
import { formatMXN } from "@/lib/format";
import OriginalCurrencyTooltip from "@/components/quote/OriginalCurrencyTooltip";
import UserCurrencyPrice from "@/components/quote/UserCurrencyPrice";

export default function SelectedRateView({ chosen, user, onCapture, onRegister, onLogin, onBack }) {
  if (!chosen) return null;
  return (
    <div className="flex flex-col items-center text-center gap-4 py-6 px-5">
      <div className="w-12 h-12 flex items-center justify-center bg-cyan/10 border border-cyan/40">
        <Package2 className="w-6 h-6 text-cyan" />
      </div>
      <div>
        <h4 className="font-display font-bold text-lg">¡Tarifa seleccionada!</h4>
        <p className="text-sm text-ink-muted mt-1">
          {getCarrier(chosen.carrier).name} · {chosen.service || "—"} ·{" "}
          <OriginalCurrencyTooltip rate={chosen}>
            <span className="text-cyan font-bold cursor-help">
              <UserCurrencyPrice mxn={chosen.total_cost} size="sm" />
            </span>
          </OriginalCurrencyTooltip>
        </p>
      </div>
      {user ? (
        <>
          <p className="text-xs text-ink-muted max-w-sm">
            Continúa con la captura de los datos de tu envío y el pago para generar tu guía.
          </p>
          <button onClick={onCapture}
            className="flex items-center justify-center gap-1.5 bg-cyan hover:bg-cyan-hover text-ink py-3 px-6 font-display font-bold uppercase text-sm glow-cyan w-full max-w-sm">
            Capturar y generar guía <ArrowRight className="w-4 h-4" />
          </button>
        </>
      ) : (
        <>
          <p className="text-xs text-ink-muted max-w-sm">
            Para continuar con la captura de tu guía y el pago, inicia sesión o crea tu cuenta gratis. Guardamos tu cotización para que no la pierdas.
          </p>
          <div className="flex flex-col sm:flex-row gap-2 w-full max-w-sm">
            <button onClick={onRegister}
              className="flex-1 flex items-center justify-center gap-1.5 bg-cyan hover:bg-cyan-hover text-ink py-3 font-display font-bold uppercase text-sm glow-cyan">
              Crear cuenta gratis <ArrowRight className="w-4 h-4" />
            </button>
            <button onClick={onLogin}
              className="flex-1 py-3 font-display font-bold uppercase text-sm border border-ink-border text-ink-text hover:border-cyan hover:text-cyan">
              Iniciar sesión
            </button>
          </div>
        </>
      )}
      <button onClick={onBack} className="text-xs text-ink-muted hover:text-ink-text mt-1">
        ← Volver a las tarifas
      </button>
    </div>
  );
}